/**
 * Formatadores únicos das páginas de Marketing. Toda métrica passa por aqui
 * para sair igual em qualquer página (moeda sempre com 2 casas, percentual
 * com 1 casa).
 */

const BRL = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})
const INT = new Intl.NumberFormat('pt-BR')

const num = (v) => {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

export const fmtBRL = (v) => BRL.format(num(v))
export const fmtNum = (v) => INT.format(Math.round(num(v)))
export const fmtPct = (v) => `${num(v).toFixed(1).replace('.', ',')}%`
export const fmtDecimal = (v) => num(v).toFixed(2).replace('.', ',')
export const fmtMultiplier = (v) => `${num(v).toFixed(1).replace('.', ',')}x`

/** Formata por nome de formato ('currency' | 'percent' | 'decimal' | 'multiplier' | 'number'). */
export function fmtByFormat(value, format = 'number') {
  switch (format) {
    case 'currency': return fmtBRL(value)
    case 'percent': return fmtPct(value)
    case 'decimal': return fmtDecimal(value)
    case 'multiplier': return fmtMultiplier(value)
    default: return fmtNum(value)
  }
}
